import { Download, X } from 'lucide-react';
import { Button } from '@ridemaadi/ui';
import { useInstallPrompt } from './useInstallPrompt';

/** Non-intrusive prompt to install the PWA to the home screen. */
export function InstallBanner() {
  const { canInstall, install, dismiss } = useInstallPrompt();
  if (!canInstall) return null;

  return (
    <div className="fixed inset-x-3 bottom-20 z-40 flex items-center gap-3 rounded-xl border border-border bg-surface p-3 shadow-lg">
      <Download className="h-5 w-5 shrink-0 text-primary" />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-medium">Install RideMaadi</p>
        <p className="truncate text-xs text-muted">Add to your home screen for a full-screen app.</p>
      </div>
      <Button size="sm" onClick={install}>
        Install
      </Button>
      <button aria-label="Dismiss" onClick={dismiss} className="rounded p-1 text-muted hover:text-fg">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
